var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.resend}},[_vm._v(" Resend ")])
}
var staticRenderFns = []

export { render, staticRenderFns }